import React, { useEffect, useMemo, useState } from 'react';

const ImageZoomPreviewModal = ({ isOpen, imageUrl, imageName, onClose }) => {
  const [zoom, setZoom] = useState(1);

  useEffect(() => {
    if (isOpen) setZoom(1);
  }, [isOpen, imageUrl]);

  const safeZoom = useMemo(() => Math.max(1, Math.min(3, zoom)), [zoom]);

  if (!isOpen || !imageUrl) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-5xl max-h-[92vh] flex flex-col">
        <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200">
          <div className="min-w-0">
            <h3 className="text-sm font-semibold text-gray-900 truncate">
              {imageName || 'Image preview'}
            </h3>
            <p className="text-xs text-gray-500">Zoom and inspect before submitting.</p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="ml-3 inline-flex h-8 w-8 items-center justify-center rounded-md border border-gray-300 text-gray-700 hover:bg-gray-100"
            aria-label="Close image preview"
          >
            ×
          </button>
        </div>

        <div className="px-4 py-3 border-b border-gray-200 flex items-center gap-3">
          <label htmlFor="image-zoom-range" className="text-sm text-gray-700 whitespace-nowrap">
            Zoom
          </label>
          <input
            id="image-zoom-range"
            type="range"
            min={1}
            max={3}
            step={0.05}
            value={safeZoom}
            onChange={(e) => setZoom(Number(e.target.value))}
            className="w-full"
          />
          <span className="text-sm text-gray-700 w-14 text-right">{safeZoom.toFixed(2)}x</span>
          <button
            type="button"
            onClick={() => setZoom(1)}
            className="text-xs px-2 py-1 rounded border border-gray-300 text-gray-700 hover:bg-gray-100"
          >
            Reset
          </button>
        </div>

        <div className="flex-1 overflow-auto bg-gray-100">
          <div className="min-h-full min-w-full flex items-center justify-center p-4">
            <img
              src={imageUrl}
              alt={imageName || 'Selected preview'}
              className="max-w-full max-h-[72vh] object-contain transition-transform duration-150"
              style={{ transform: `scale(${safeZoom})`, transformOrigin: 'center center' }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageZoomPreviewModal;

